import React from 'react';
import { PriceDisplay, PriceDisplayProps, SavingDisplay } from './PriceDisplay';

export const BILLING_CURRENCY_NOTE = 'Billed in South African rand. You can select your currency at checkout.';

export interface PriceProps extends PriceDisplayProps {}

export const Price: React.FC<PriceProps> = (props) => {
  return <PriceDisplay {...props} />;
};

export { PriceDisplay, SavingDisplay };
export default Price;
